import { TableCellProps, Th } from '@chakra-ui/table';
import React from 'react';

export const CmTh: React.FC<TableCellProps> = ({
  position = 'sticky',
  bgColor = 'white',
  textAlign = 'center',
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <Th
      // @ts-ignore TS2590
      top="0"
      padding="10px"
      {...{ textAlign, position, bgColor, ...rest }}
      style={{ textTransform: 'none' }}
    />
  );
};
